<template>
  <div class="login-form__protocol-checkbox-wrapper">
    <Checkbox
      v-if="useCheckbox"
      v-model:checked="checked"
      :class="['login-form__protocol-checkbox', { 'is-us': !isChinese() }]"
      @change="handleChange"
      :text-variant="'12'"
      :text-color="'t5'"
      :text-weight="'regular'"
    >
      <span>{{ prefixText }}</span>
      <Link
        :class="['login-form__protocol-checkbox-link', { 'force-underline': !isChinese() }]"
        :href="userAgreementUrl"
        name="user"
        target="_blank"
        :underline="!isChinese()"
      >
        {{ userAgreementText }}
      </Link>
      <span>{{ middleText }}</span>
      <Link
        :class="['login-form__protocol-checkbox-link', { 'force-underline': !isChinese() }]"
        :href="privacyPolicyUrl"
        name="policy"
        target="_blank"
        :underline="!isChinese()"
      >
        {{ privacyPolicyText }}
      </Link>
    </Checkbox>
    <div v-else :class="'login-form__protocol-checkbox'">
      <Text
        class="login-form__protocol-checkbox-content"
        :variant="'12'"
        :color="'t5'"
        :weight="'regular'"
      >
        <span>{{ prefixText }}</span>
        <Link
          :class="['login-form__protocol-checkbox-link', { 'force-underline': !isChinese() }]"
          :href="userAgreementUrl"
          name="user"
          target="_blank"
          :underline="!isChinese()"
        >
          {{ userAgreementText }}
        </Link>
        <span>{{ middleText }}</span>
        <Link
          :class="['login-form__protocol-checkbox-link', { 'force-underline': !isChinese() }]"
          :href="privacyPolicyUrl"
          name="policy"
          target="_blank"
          :underline="!isChinese()"
        >
          {{ privacyPolicyText }}
        </Link>
      </Text>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Checkbox } from '@rendora/design/components/checkbox';
import { Link } from '@rendora/design/components/link';
import Text from '@rendora/design/components/text/Text.vue';

interface Props {
  // 是否使用 Checkbox 组件
  useCheckbox?: boolean;
  // Checkbox 的 v-model 值（仅在 useCheckbox 为 true 时使用）
  modelValue?: boolean;
  // 用户协议链接
  userAgreementUrl: string;
  // 隐私政策链接
  privacyPolicyUrl: string;
  // 用户协议文本
  userAgreementText: string;
  // 隐私政策文本
  privacyPolicyText: string;
  // 前缀文本（如"我已阅读并同意"）
  prefixText: string;
  // 中间文本（如"和"）
  middleText: string;
}

const props = withDefaults(defineProps<Props>(), {
  useCheckbox: false,
  modelValue: false,
});

const emits = defineEmits<{
  'update:modelValue': [value: boolean];
  change: [value: boolean];
}>();

const checked = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emits('update:modelValue', value);
  },
});

const handleChange = (value: boolean) => {
  emits('change', value);
};
</script>

<style lang="scss" scoped>
@use '@rendora/design/styles/mixins.scss' as *;

.login-form__protocol-checkbox-wrapper {
  margin: 32px auto 0;
  display: flex;
  justify-content: center;

  @include mobile {
    margin: responsive-size(32px) auto 0;
  }
}

.login-form__protocol-checkbox {
  display: flex;
  justify-content: center;
  color: var(--x-text-5);

  :deep(.checkbox-input-icon) {
    transform: translateY(3px);

    @include mobile {
      transform: translateY(responsive-size(1.5px));
    }
  }

  &.is-us {
    .login-form__protocol-checkbox-link {
      text-decoration: underline;
    }
  }
}

.login-form__protocol-checkbox-link {
  margin: 0 4px;

  &.force-underline {
    text-decoration: underline !important;
  }

  @include mobile {
    margin: 0 responsive-size(4px);
  }
}
</style>
